import { z } from 'zod';

export const UpdateRevisionPlanBodySchema = z
  .object({
    name: z.string().trim().min(1).max(255).optional(),
    genericProductIds: z.array(z.uuid()).min(1).optional(),
  })
  .refine((body) => body.name !== undefined || body.genericProductIds !== undefined, {
    message: 'At least one of name or genericProductIds is required',
  });

export const UpdateRevisionPlanResponseSchema = z.object({
  revisionPlanId: z.uuid(),
});

export type UpdateRevisionPlanBody = z.infer<typeof UpdateRevisionPlanBodySchema>;
export type UpdateRevisionPlanResponse = z.infer<typeof UpdateRevisionPlanResponseSchema>;
